export default class ColumnDefinition
{
    /**
     * 
     * @param {String} name 
     * @param {String} label 
     * @param {Boolean} isMain // define THE MAIN column (only one is required per listing)
     * @param {Boolean} sortable 
     * @param {Function?} formatter
     * @param {Object} configuration
     */
    constructor(name, label, isMain = false, sortable = false, formatter = null, configuration = {}) {
        this.configuration = Object.assign({
            width: "M",
            alignment: "left",
            displayable: true,
            sortableKey: null,
            exportLabel: null,
            exportKey: null,
            display: true,
            rank: false,
            prop: name,
            exportable: true
        }, configuration);

        this.name = name;
        this.configuration.name = name;
        this.configuration.label = label;
        this.configuration.isMain = isMain;
        this.configuration.sortable = sortable;
        this.formatter = formatter;
        this.metas = {};
    }

    build() {
        return Object.assign({}, this.configuration);
    }
}